import { render, staticRenderFns } from "./InvoiceInfo.vue?vue&type=template&id=4742c53e&scoped=true&"
import script from "./InvoiceInfo.vue?vue&type=script&lang=js&"
export * from "./InvoiceInfo.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceInfo.vue?vue&type=style&index=0&id=4742c53e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4742c53e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4742c53e')) {
      api.createRecord('4742c53e', component.options)
    } else {
      api.reload('4742c53e', component.options)
    }
    module.hot.accept("./InvoiceInfo.vue?vue&type=template&id=4742c53e&scoped=true&", function () {
      api.rerender('4742c53e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/submission-request/InvoiceInfo.vue"
export default component.exports